const amuletStackerConstants = {
  RESET_AMULET: "RESET_AMULET",
  SELECT_AMULET: "SELECT_AMULET",
  CHAIN_LOAD_START: "CHAIN_LOAD_START",
  CHAIN_LOAD_PENDING: "CHAIN_LOAD_PENDING",
  CHAIN_LOAD_COMPLETE: "CHAIN_LOAD_COMPLETE",
  CHAIN_LOAD_ERROR: "CHAIN_LOAD_ERROR",
  PRODUCT_LIST_EXPANDED: "PRODUCT_LIST_EXPANDED",
  RESET_CHAIN: "RESET_CHAIN",
  SET_SELECTED_CHAIN: "SELECT_CHAIN",
  SHOW_PRODUCT_INFO: "SHOW_PRODUCT_INFO",
}

export default amuletStackerConstants
